import React from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'

import DescItemInfo from 'ui-components/DescItemInfo/DescItemInfo'
import { Plan } from './styles'

export default function PaymentPlans({ paymentPlans, paymentVouchers }) {
  const renderPaymentPlans = (paymentPlan) => (
    <Plan key={`payment-plan-${paymentPlan.id}`}>
      <DescItemInfo label="Método">
        {paymentPlan.selected_method_option.label}
      </DescItemInfo>

      <DescItemInfo label="Parcela">
        {paymentPlan.selected_plan_option.label}
      </DescItemInfo>

      <DescItemInfo label="R$ Valor">
        {currencyFormat(paymentPlan.value)}
      </DescItemInfo>
    </Plan>
  )

  const renderPaymentVoucher = (voucher) => (
    <Plan key={`payment-voucher-${voucher.id}`}>
      <DescItemInfo label="Método">
        Voucher
      </DescItemInfo>

      <DescItemInfo label="Número">
        {voucher.code}
      </DescItemInfo>

      <DescItemInfo label="R$ Valor">
        {currencyFormat(voucher.value)}
      </DescItemInfo>
    </Plan>
  )

  return (
    <div>
      <h4>Formas de pagamento</h4>
      {paymentPlans.map(renderPaymentPlans)}
      {paymentVouchers.map(renderPaymentVoucher)}
    </div>
  )
}

PaymentPlans.propTypes = {
  paymentPlans: PropTypes.arrayOf(PropTypes.object),
  paymentVouchers: PropTypes.arrayOf(PropTypes.object),
}

PaymentPlans.defaultProps = {
  paymentPlans: [],
  paymentVouchers: [],
}
